import { useTranslation } from 'react-i18next'
import React from 'react'

import { useAlert } from '@btime/react-messager'

import { useCloseModal, useModalData } from '../../../components/modals/ModalsContext'
import { useSetPlaceAvailabilityStatus } from '../_actions/_requests/setAvailabilityStatus'
import AvailabilityStatusSelect from '../_shared/AvailabilityStatusSelect'
import Form from '../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../packages/kiti/components/form/form/FormItem'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import TextArea from '../../../packages/kiti/components/form/Textarea'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'

const otherStatus = status => (status === 'available' ? 'unavailable' : 'available')

const ChangeAvailabilityStatusForm = () => {
  const { t } = useTranslation('availability')
  const { placeId, currentStatus } = useModalData() || {}
  const [request, { loading, error }] = useSetPlaceAvailabilityStatus()
  const modal = useAlert()
  const closeModal = useCloseModal()

  const initialState = { status: otherStatus(currentStatus), reason: '' }

  const handleSubmit = form => {
    if (!modal.confirm({ title: t('confirmChangeStatus') })) return false

    return request({ placeId, status: form.status, reason: form.reason }).then(resp => {
      if (resp) closeModal()
    })
  }

  return (
    <Form loading={loading} onSubmit={handleSubmit} initialState={initialState}>
      <Grid paddingGutter={0.5} wrap>
        <Col width="100%">
          <FormItem label={t('changeStatusTo')} field="status" Input={AvailabilityStatusSelect} />
        </Col>

        <Col width="100%">
          <FormItem label={t('reason')} field="reason" Input={TextArea} placeholder={t('reasonPlaceholder')} />
        </Col>
      </Grid>

      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default ChangeAvailabilityStatusForm
